/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AmbulanzType = {
    Ambulanz: 'Ambulanz',
    Callback: 'Callback',
    Sms: 'Sms'
} as const;
export type AmbulanzType = typeof AmbulanzType[keyof typeof AmbulanzType];


export function instanceOfAmbulanzType(value: any): boolean {
    for (const key in AmbulanzType) {
        if (Object.prototype.hasOwnProperty.call(AmbulanzType, key)) {
            if (AmbulanzType[key as keyof typeof AmbulanzType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AmbulanzTypeFromJSON(json: any): AmbulanzType {
    return AmbulanzTypeFromJSONTyped(json, false);
}

export function AmbulanzTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AmbulanzType {
    return json as AmbulanzType;
}

export function AmbulanzTypeToJSON(value?: AmbulanzType | null): any {
    return value as any;
}

export function AmbulanzTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): AmbulanzType {
    return value as AmbulanzType;
}

